/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, { FC, useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Container, useMediaQuery, useTheme } from "@mui/material";
import Connexion from "./connexion/Connexion";
import Inscription from "./inscription/Inscription";
import classes from "./style";
import ConnexionMail from "./connexion/connexion-mail";
import InscriptionMail from "./inscription/inscription-mail";
import { TabPanel, a11yProps } from "../../helpers/tabPanels";
import { clearParamsFromCurrentUrl } from "utils/url";
import { useLocation, useNavigate } from "react-router-dom";

const Authentication: FC<{}> = () => {
  const [value, setValue] = React.useState(0);
  const theme = useTheme();
  const [loginMode, setLoginMode] = React.useState<string | null>(null);
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const [params, setParams] = useState<string>();
  const location = useLocation();

  const navigate = useNavigate();

  const handleBack = () => {
    setLoginMode(null);
  }

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    setParams(location.search);
    clearParamsFromCurrentUrl();
  }, []);

  return (
    <Container disableGutters maxWidth={false} sx={classes.authContainer}>
      <Box sx={{ width: isSm ? '80%' : (isMd ? '60%' : null), marginX: 3 }}>
        <Box>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor: "transparent",
              },
            }}
          >
            <Tab label="Connexion" {...a11yProps(0)} />
            <Tab label="Inscription" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          {loginMode === "mail" ? (
            <ConnexionMail search={params} />
          ) : (
            <Connexion changeLoginMode={(mode: string) => setLoginMode(mode)} search={params} />
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {loginMode === "inscriptionMail" ? (
            <InscriptionMail search={params} />
          ) : (
            <Inscription
              changeInscriptionMode={(mode: string) => setLoginMode(mode)}
              search={params}
            />
          )}
        </TabPanel>
      </Box>
    </Container>
  );
};

export default Authentication;
